import React from 'react';
import { Head } from '@inertiajs/react';
import AppTextLogo from '@/Components/Utility/AppTextLogo';

export default function ErrorPage({ status }) {
  const title = {
    503: '503: Service Unavailable',
    500: '500: Server Error',
    404: '404: Page Not Found',
    403: '403: Forbidden',
  }[status];

  const description = {
    503: 'Sorry, we are doing some maintenance. Please check back soon.',
    500: 'Whoops, something went wrong on our servers.',
    404: 'Sorry, the page you are looking for could not be found.',
    403: 'Sorry, you are forbidden from accessing this page.',
  }[status];

  return (
    <div className="items-top relative flex min-h-screen items-center justify-center sm:pt-0">
      <Head>
        <title>{title}</title>
        <meta
          name="description"
          content={`Profile Links - Transform your digital performance`}
        />
        <meta
          name="keywords"
          content="graphic design, web developer, developer, leeds design, leeds developer, leeds laravel, leeds vue, design studio, design studio leeds"
        />
        <meta property="og:url" content={window.location.href} />
        <link rel="alternate" href="https://madeby.studio" hreflang="en-GB" />
        <meta property="og:site_name" content="madeby.studio - Profiles" />
        <meta name="twitter:title" content={`Profile Links | madeby.studio`} />
        <meta
          name="twitter:description"
          content={`Profile Links Links - Transform your digital performance`}
        />

        <meta property="og:title" content={`Profile Links | madeby.studio`} />
        <meta
          property="og:description"
          content={`Profile Links Links - Transform your digital performance`}
        />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en-GB" />
        <meta
          property="og:image"
          content="https://madeby.studio/assets/branding/meta-opengraph.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:image:alt"
          content="madeby.studio - Team Working and Strapline"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://madeby.studio/assets/branding/twitter-opengraph.png"
        />
        <meta name="twitter:site" content="@madebystudio" />
        <meta name="twitter:creator" content="@madebystudio" />
      </Head>

      <div className="flex w-full flex-col px-8 md:max-w-screen-xl md:px-0">
        <div className="flex w-full flex-col items-center px-8 text-center">
          <AppTextLogo style="dark" />
          <h1 className="mt-8 text-4xl leading-tight text-dark md:mt-auto md:text-5xl">
            {title}
            <span className="text-primary">.</span>
          </h1>
          <p className="text-grey md:-mt-4">{description}</p>
        </div>
      </div>
    </div>
  );
}
